<template>
  <div class="dashboard_page">
    <div class="row">
      <template v-if="BRAND == 'IM'">
        <icon-block
          txt-color="D80027"
          img-name="orders"
          router-link="/orders"
          block-title="Orders"
        ></icon-block>
        <icon-block
          txt-color="FFDA44"
          img-name="stock"
          router-link="/stock"
          block-title="Stock"
        ></icon-block>
        <icon-block
          txt-color="933ec5"
          img-name="packages"
          router-link="/packages"
          block-title="Packages"
        ></icon-block>
        <icon-block
          txt-color="91DC5A"
          img-name="dispatch"
          router-link="/dispatch"
          block-title="Dispatch"
        ></icon-block>
        <icon-block
          txt-color="006df0"
          img-name="payment"
          router-link="/payments"
          block-title="Payments"
        ></icon-block>
        <icon-block
          txt-color="a40a31"
          img-name="shipments"
          router-link="/shipments"
          block-title="Shipments"
        ></icon-block>
        <icon-block
          txt-color="000000"
          img-name="ingredients"
          router-link="/ingredients"
          block-title="Ingredients"
        ></icon-block>
        <icon-block
          txt-color="0d5fa5"
          img-name="rawShipment"
          router-link="/raw/shipments"
          block-title="Raw Shipments"
        ></icon-block>
        <icon-block
          txt-color="0d5fa5"
          img-name="testingRequests"
          router-link="/testing/requests"
          block-title="Testing Requests"
        ></icon-block>
      <icon-block
          txt-color="000000"
          img-name="envelopes"
          router-link="/envelopes"
          block-title="Envelopes"
      ></icon-block>
      <icon-block
          txt-color="000000"
          img-name="barcode"
          router-link="/tracking-numbers"
          block-title="Tracking Numbers"
      ></icon-block>
      </template>

      <template v-if="BRAND == 'SM'">
        <icon-block
          txt-color="D80027"
          img-name="orders"
          router-link="/orders"
          block-title="Orders"
        ></icon-block>
        <icon-block
          txt-color="FFDA44"
          img-name="stock"
          router-link="/stock"
          block-title="Stock"
        ></icon-block>
        <icon-block
          txt-color="933ec5"
          img-name="packages"
          router-link="/packages"
          block-title="Packages"
        ></icon-block>
        <icon-block
          txt-color="91DC5A"
          img-name="dispatch"
          router-link="/dispatch"
          block-title="Dispatch"
        ></icon-block>
        <icon-block
          txt-color="a40a31"
          img-name="shipments"
          router-link="/shipments"
          block-title="Shipments"
        ></icon-block>
        <icon-block
        txt-color="000000"
        img-name="ingredients"
        router-link="/ingredients"
        block-title="Ingredients"
        ></icon-block>
        <icon-block
          txt-color="0d5fa5"
          img-name="rawShipment"
          router-link="/raw/shipments"
          block-title="Raw Shipments"
        ></icon-block>
        <icon-block
          txt-color="0d5fa5"
          img-name="testingRequests"
          router-link="/testing/requests"
          block-title="Testing Requests"
        ></icon-block>
        <icon-block
          txt-color="000000"
          img-name="envelopes"
          router-link="/envelopes"
          block-title="Envelopes"
        ></icon-block>
      </template>

      <template v-if="BRAND == 'VM'">
        <!-- <icon-block
          txt-color="D80027"
          img-name="orders"
          router-link="/orders"
          block-title="Orders"
        ></icon-block> -->
        <icon-block
          txt-color="FFDA44"
          img-name="stock"
          router-link="/stock"
          block-title="Stock"
        ></icon-block>
        <!-- <icon-block
          txt-color="933ec5"
          img-name="packages"
          router-link="/packages"
          block-title="Packages"
        ></icon-block> -->
        <!-- <icon-block
          txt-color="91DC5A"
          img-name="dispatch"
          router-link="/dispatch"
          block-title="Dispatch"
        ></icon-block> -->
      </template>

      <template v-if="BRAND == 'FF'">
        <icon-block
          txt-color="D80027"
          img-name="orders"
          router-link="/orders"
          block-title="Orders"
        ></icon-block>
        <icon-block
          txt-color="FFDA44"
          img-name="stock"
          router-link="/stock"
          block-title="Stock"
        ></icon-block>
        <icon-block
          txt-color="933ec5"
          img-name="packages"
          router-link="/packages"
          block-title="Packages"
        ></icon-block>
        <icon-block
          txt-color="a40a31"
          img-name="shipments"
          router-link="/shipping"
          block-title="Shipping"
        ></icon-block>
        <icon-block
          txt-color="91DC5A"
          img-name="dispatch"
          router-link="/dispatch"
          block-title="Dispatch"
        ></icon-block>
      </template>

      <template v-if="BRAND == 'EB'">
        <icon-block
          txt-color="D80027"
          img-name="orders"
          router-link="/orders"
          block-title="Orders"
        ></icon-block>
        <icon-block
          txt-color="91DC5A"
          img-name="dispatch"
          router-link="/dispatch"
          block-title="Dispatch"
        ></icon-block>
        <icon-block
          txt-color="215F95"
          img-name="mappings"
          router-link="/mappings"
          block-title="Mappings"
        ></icon-block>
      </template>
    </div>
  </div>
</template>

<script>
import IconBlock from "@/components/dashboard/IconBlock.vue";
export default {
  name: "orders",
  components: {
    IconBlock
  }
};
</script>
